import { render, staticRenderFns } from "./GridValidacionHistorico.vue?vue&type=template&id=32144185&"
import script from "./GridValidacionHistorico.vue?vue&type=script&lang=js&"
export * from "./GridValidacionHistorico.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports